import type { RootState } from 'store/configureStore';

import { types } from './actions';
import { InterrogationInfo } from './types';

type GeometricInterrogationState = {
  isEditingInterrogationSetup: boolean;
  isFetching: boolean;
  query: {
    material: string | null;
    task: string | null;
  };
  searchResults: InterrogationInfo[];
  selectedResult: InterrogationInfo | null;
};

const initialState: GeometricInterrogationState = {
  isEditingInterrogationSetup: false,
  isFetching: false,
  query: {
    material: null,
    task: null,
  },
  searchResults: [],
  selectedResult: null,
};

const reducer = (
  state = initialState,
  action: { type: string; payload: unknown },
) => {
  const { payload, type } = action;
  switch (type) {
    case types.CANCEL_EDIT_INTERROGATION_SETUP:
      return {
        ...state,
        isEditingInterrogationSetup: false,
      };
    case types.CLEAR:
      return {
        ...state,
        query: initialState.query,
        searchResults: [],
        selectedResult: null,
      };
    case types.EDIT_INTERROGATION_SETUP:
      return {
        ...state,
        isEditingInterrogationSetup: true,
      };
    case types.RECEIVE_QUERY:
      return {
        ...state,
        isFetching: true,
        query: {
          material: payload.material,
          task: payload.task,
        },
      };
    case types.RECEIVE_RESULT_FOR_DEFAULT:
      return {
        ...state,
        selectedResult: payload.result,
      };
    case types.RECEIVE_SEARCH_RESULTS:
      return {
        ...state,
        isFetching: false,
        searchResults: payload.results,
      };
    case types.SUBMIT:
      return {
        ...state,
        isEditingInterrogationSetup: false,
        selectedResult: payload.result,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state: RootState): GeometricInterrogationState =>
  state.modules.viewerPage.app.geometricInterrogation;

export const getIsEditingInterrogationSetup = (state: RootState) =>
  getScope(state).isEditingInterrogationSetup;

export const getIsFetching = (state: RootState) => getScope(state).isFetching;

export const getQuery = (state: RootState) => getScope(state).query;

export const getSearchResults = (state: RootState) =>
  getScope(state).searchResults;

export const getSelectedResult = (state: RootState) =>
  getScope(state).selectedResult;
